export default __webpack_public_path__ + "static/media/materiale-propaganda-nc.ec446fcd.svg";